import { render, staticRenderFns } from "./travelzun_izq.vue?vue&type=template&id=eb8b5828&"
import script from "./travelzun_izq.vue?vue&type=script&lang=js&"
export * from "./travelzun_izq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports